import { Button, FieldError, Input, Label, TextArea, TextField } from "@heroui/react";
import { Controller } from "react-hook-form";
import SelectField from "@/src/common/components/select-field";
import { GENRE_OPTIONS } from "@/src/common/constants/studio-labels";
import { useCreateSeries } from "@/src/series/hooks/use-create-series";

type CreateSeriesPanelProps = {
	onCreated: (seriesId: string) => void;
	onCancel: () => void;
};

const CreateSeriesPanel: React.FC<CreateSeriesPanelProps> = ({ onCreated, onCancel }) => {
	const { form, submit, error, isSubmitting } = useCreateSeries(onCreated);

	return (
		<form onSubmit={submit} className="flex flex-col gap-4 rounded-xl border border-border-soft bg-surface p-5">
			{error ? <p className="rounded-lg border border-border-soft bg-glass p-3 text-danger text-sm">{error}</p> : null}
			<Controller
				control={form.control}
				name="title"
				render={({ field, fieldState }) => (
					<TextField isInvalid={Boolean(fieldState.error)} value={field.value} onChange={field.onChange} onBlur={field.onBlur}>
						<Label>Titre de la série</Label>
						<Input placeholder="Le Signal" />
						<FieldError>{fieldState.error?.message}</FieldError>
					</TextField>
				)}
			/>
			<Controller
				control={form.control}
				name="synopsis"
				render={({ field, fieldState }) => (
					<TextField isInvalid={Boolean(fieldState.error)} value={field.value} onChange={field.onChange} onBlur={field.onBlur}>
						<Label>Synopsis</Label>
						<TextArea placeholder="Le pitch de la série" rows={3} />
						<FieldError>{fieldState.error?.message}</FieldError>
					</TextField>
				)}
			/>
			<Controller
				control={form.control}
				name="genre"
				render={({ field }) => <SelectField label="Genre" options={GENRE_OPTIONS} value={field.value} onChange={field.onChange} />}
			/>
			<div className="flex items-center justify-end gap-2">
				<Button variant="ghost" onPress={onCancel} className="text-muted">
					Annuler
				</Button>
				<Button type="submit" isDisabled={isSubmitting}>
					{isSubmitting ? "Création…" : "Créer la série"}
				</Button>
			</div>
		</form>
	);
};

export default CreateSeriesPanel;
